var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.contentHover,"placement":"top","disabled":_vm.isShowTooltip}},[_c('div',{staticClass:"overview_container",style:({ padding: `0 ${_vm.paddingLR}px` }),on:{"mouseover":function($event){return _vm.onMouseOver()}}},[_c('div',[_c('span',{ref:"name"},[_vm._v(_vm._s(_vm.content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }